import React from "react";
import ArrowBack from "@images/profile/arrow_back.svg";
import ProfileOverviewMap from "@images/profile/profileOverviewMap.svg";
import FrodobotBlueOverview from "@images/profile/frodobotBlueOverview.svg";
import FrodobotRedOverview from "@images/profile/frodobotRedOverview.svg";

const OverViewProfile = () => {
  const weekData = [
    {
      label: "This week",
    },
    {
      label: "1st Warning",
    },
    {
      label: "2st Warning",
    },
  ];
  const overViewData = [
    {
      label: "30km",
      distance: "Distance Travelled",
    },
    {
      label: "200",
      per: "30%",
      distance: "EXP Gained",
    },
    {
      label: "10",
      per: "30%",
      distance: "Missions Completed",
    },
    {
      label: "120 min",
      per: "30%",
      distance: "Time Elapsed",
    },
  ];

  const missionsData = [
    {
      label: "Highest Earning Mission",
      details: "+57XP",
      missionsymbolImg: FrodobotRedOverview,
      missionLabel: "Frodobot-001",
      missionDetalis: "Mission 181",
      missionImg: ProfileOverviewMap,
    },
    {
      label: "Lowest Earning Mission",
      details: "0XP (Did not Finish)",
      missionsymbolImg: FrodobotBlueOverview,
      missionLabel: "Frodobot-004",
      missionDetalis: "Mission 192",
      missionImg: ProfileOverviewMap,
    },
  ];

  return (
    <div className="flex gap-y-[16px] flex-col">
      <div className="flex gap-[10px] items-center">
        <p className="w-[112px] truncate text-gray text-[18px] leading-[28px] font-medium">
          Overview for text text
        </p>
        <div>
          <select
            name="overview"
            id="overview"
            className="focus:focus-visible:outline-none bg-white rounded-lg w-[144px] border"
          >
            {weekData.map((item, index) => (
              <option value={index} key={index}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2  xl:gap-[16px] lg:gap-[12px] gap-[8px]">
        {overViewData.map((item, index) => (
          <div
            className="bg-white xl:p-[16px] lg:p-[12px] p-[8px] rounded-2xl"
            key={index}
          >
            <div className="flex gap-x-[8px] items-center">
              <p className="xl:text-[32px] xl:leading-[32px] lg:text-[30px] lg:leading-[36px] text-[24px]	leading-[32px] text-black font-semibold">
                {item.label}
              </p>
              {item.per && (
                <div className="flex gap-px text-white bg-green rounded-lg p-[2px] xl:text-[20px]  lg:text-[18px] lg:leading-[28px] md:text-[16px] md:leading-[24px] text-[14px] leading-[20px]">
                  <div className="rotate-90">
                    <img src={ArrowBack} />
                  </div>
                  {item.per}
                </div>
              )}
            </div>
            <div className="text-gray font-medium xl:text-[18px] xl:leading-[28px] lg:text-[16px] lg:leading-[28px] text-[14px] leading-[20px]">
              {item.distance}
            </div>
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-[16px]">
        {missionsData.map((item, index) => (
          <div
            className="bg-white xl:p-[16px] lg:p-[12px] p-[8px] rounded-2xl flex flex-col gap-[16px]"
            key={index}
          >
            <div>
              <p className="text-gray text-[16px] font-medium">
                {item.label}
              </p>
              <h6 className="text-[24px] leading-[32px] text-black my-0 font-semibold">
                {item.details}
              </h6>
            </div>
            <div className="grid grid-cols-2">
              <div>
                <div>
                  <img src={item.missionsymbolImg} />
                </div>
                <h6 className="text-[24px] leading-[32px] text-black font-semibold my-0">{item.missionLabel}</h6>
                <p className="text-gray text-[16px] font-medium">{item.missionDetalis}</p>
              </div>
              <div className="border-1 border-white border-solid">
                <img src={item.missionImg} className="h-[124px] w-full" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OverViewProfile;
